import React, { useContext, useEffect, useState } from "react";
import { Button, Checkbox, FormControl, InputAdornment, Typography, Tooltip, TooltipProps, tooltipClasses, useMediaQuery, Theme } from "@mui/material";
import { blue, purple } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { EmailOutlined, PersonOutline, PhoneOutlined } from "@mui/icons-material";
import { isCPFValid, isEmailValid, isPhoneValid } from "@fac/props-helpers";
import { useInputOnChange } from "@fac/react-hooks";
import { FacTextField, FacTextFieldCPF, FacTextFieldPhone, MultiStepContextLayout } from "@fac/standard-ui-lib";
import ClientStepRoot, { ClientStepForm } from "./ClientStep.styles";
import ClientContextLayout from "../../modules/Client/Client.context";
import APIService from "../../modules/API/API.service";
import { useGetPendencies } from "../../modules/Serpro";
import { Document, Page } from "react-pdf";
import { lgpdBase64 } from "./assets/LGPD"; 
import type { PDFDocumentProxy } from 'pdfjs-dist';
import AgreementModal from "./components/AgreementModal.component";

export const ClientStep = () => {
    const { presvStep, nextStep, step } = useContext(MultiStepContextLayout);
    const { client, setClient } = useContext(ClientContextLayout);
    const {  getCCMEI } = useGetPendencies();
    const [email, setEmail] = useState<string | undefined>();
    const [emailError, setEmailError] = useState<boolean>(false);
    const [phone, setPhone] = useState<string | undefined>();
    const [phoneError, setPhoneError] = useState<boolean>(false);
    const [CPF, setCPF] = useState<string | undefined>();
    const [CPFError, setCPFError] = useState<boolean>(false);
    const [consent, setConsent] = useState<boolean>(false);
    const [ focused, setFocused ] = useState<boolean>(false);
    const { onChange: onChangeEmail } = useInputOnChange<string | undefined>(setEmail);
    const { onChange: onChangeCPF } = useInputOnChange<string | undefined>(setCPF);
    const { onChange: onChangePhone } = useInputOnChange<string | undefined>(setPhone);
    const [ numPages, setNumPages ] = useState(4)
    const [ isAgreementModalOpen, setIsAgreementModalOpen ] = useState(false)
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));


    const onCheckConsent = (/*event: React.ChangeEvent<HTMLInputElement>*/) => {
        setConsent(true);
        setIsAgreementModalOpen(false)
    };

    const closeAgreementModal = () => {
        setIsAgreementModalOpen(false)
    }

    const onConfirm = async () => {
        if (!CPF || CPFError || !phone || phoneError || !email || emailError) return;
        setClient({ ...client, cpf: CPF, phone, email });

        if (client) {
            console.log('Clicou no confirmrar')
            const req = await APIService.saveConsult(client);
            console.log('resposta', req)
        }

        nextStep();
    };


    const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#321e3b",
            color: "#FFFF",
            boxShadow: theme.shadows[1],
            fontSize: 14,
        },
    }));

    const getMeiCpf = async () => {
        if(client?.cnpj && !client?.cpf){
            const CCMEI = await getCCMEI(client?.cnpj);
            const meiCPF = CCMEI?.data?.empresario?.cpf as string;
             
            setCPF(meiCPF);

        };
    };

    useEffect(() => {
        if (email) {
            setEmailError(!isEmailValid(email));
            setClient({ ...client, cpf: CPF, phone, email });
        }
    }, [email, setEmailError]);

    useEffect(() => {
        if (CPF) {
            setCPFError(!isCPFValid(CPF));
            setClient({ ...client, cpf: CPF, phone, email });
        }
    }, [CPF, setCPFError]);

    useEffect(() => {
        if (phone) {
            setPhoneError(!isPhoneValid(phone));
            setClient({ ...client, cpf: CPF, phone, email });
        }
    }, [phone, phoneError]);

    useEffect(() => {
        if (client?.email) setEmail(client?.email.toLowerCase());
        if (client?.phone) setPhone(client?.phone);
        if (client?.cpf) setCPF(client?.cpf);
    }, [client]);

    useEffect(() => {
        if(step === 2) getMeiCpf();
    }, [step]);
    
    const googleDriveOAuthToken = async () => {
        const reader = new FileReader()
    }
    
    function onDocumentLoadSuccess({ numPages: nextNumPages }: PDFDocumentProxy): void {
        setNumPages(nextNumPages);
    }
    return (
        <ClientStepRoot>
            <Typography variant="h6" component="h2" color="white" fontWeight={200}>
                Por favor, confirme os <b>dados de contato</b>
            </Typography>
            <FormControl fullWidth>
                <ClientStepForm
                    onSubmit={(e) => {
                        e?.preventDefault();
                        onConfirm();
                    }}
                >
                    <FacTextFieldCPF
                        label=""
                        id="cpf"
                        defaultValue={client?.cpf}
                        onFocus={() => setFocused(!focused)}
                        onChange={onChangeCPF}
                        value={CPF}
                        hiddenLabel
                        variant="filled"
                        subVariant="clean-transparent"
                        placeholder="CPF"
                        error={CPFError}
                        helperText={CPFError && "É necessário um CPF válido."}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonOutline color="inherit" sx={{ opacity: 0.4 }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Tooltip
                        title="Este endereço será usado para enviar o relatório de pendências."
                        open={false}
                        placement={isMobile ? "bottom" : "right"}
                        arrow
                    >
                        <FacTextField
                            label=""
                            id="email"
                            hiddenLabel
                            //onFocus={() => setFocused(!focused)}
                            // onFocus={() => console.log('onFOcus email')}
                            onChange={onChangeEmail}
                            value={email}
                            error={emailError}
                            variant="filled"
                            subVariant="clean-transparent"
                            placeholder="E-mail"
                            style={{ paddingBottom: isMobile ? 30 : 0 }}
                            helperText={
                                emailError ? "É necessário um E-mail válido."
                                : isMobile ? "Este e-mail será usado para enviar o relatório de pendências." : "Este e-mail será usado para enviar o relatório de pendências."
                            }
                            FormHelperTextProps={{}}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EmailOutlined color="inherit" sx={{ opacity: 0.4 }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Tooltip>
                    <FacTextFieldPhone
                        label=""
                        hiddenLabel
                        id="phone"
                        //onFocus={() => setFocused(!focused)}
                        value={phone}
                        onChange={onChangePhone}
                        variant="filled"
                        subVariant="clean-transparent"
                        placeholder="Telefone"
                        helperText={phoneError && "É necessário um telefone válido."}
                        error={phoneError}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PhoneOutlined color="inherit" sx={{ opacity: 0.4 }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                        {/* { <Checkbox
                            checked={consent}
                            onChange={onCheckConsent}
                            inputProps={{ "aria-label": "controlled" }}
                            sx={{
                                color: purple,
                                "&.Mui-checked": {
                                    color: blue[600],
                                },
                            }}
                        />

                        <Typography variant="body1" component="h4" color="white" fontWeight={400}>
                            Declaro que estou ciente e de acordo com a coleta, armazenamento e
                            tratamento dos meus dados pessoais conforme estabelecido pela Lei Geral
                            de Proteção de Dados (LGPD), para os fins especificados pela Faço a
                            Conta.
                        </Typography>} */}
                        <Checkbox
                            checked={consent}
                            onChange={() => setIsAgreementModalOpen(!isAgreementModalOpen)}
                            inputProps={{ "aria-label": "controlled" }}
                            sx={{
                                color: purple,
                                "&.Mui-checked": {
                                    color: blue[600],
                                },
                            }}
                        />

                        <Typography variant="body1" component="h4" color="white" fontWeight={400}>
                            Li e estou de acordo com os termos de uso.
                        </Typography>
                        <AgreementModal
                            handleClose={closeAgreementModal}
                            open={isAgreementModalOpen}
                            onAgree={onCheckConsent}
                        />
                        {/* <>
                            <Document file={`data:application/pdf;base64,${lgpdBase64}`} >
                                 
                                {Array.from(new Array(numPages), (_el, index) => (
                                    <>
                                        <Page
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                            width={600}
                                            renderAnnotationLayer={false}
                                            renderTextLayer={false}
                                        />
                                        
                                    </>
                                    
                                ))}
                            </Document>
                        </> */}
                    </div>

                    <footer>
                        <Button variant="clean" onClick={presvStep}>
                            Voltar
                        </Button>
                        {CPF &&
                            !CPFError &&
                            phone &&
                            !phoneError &&
                            email &&
                            !emailError &&
                            consent && (
                                <Button
                                    className="botaoConfirmarDados"
                                    type="submit"
                                    variant="clean"
                                    onClick={(
                                        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
                                    ) => {
                                        e?.preventDefault();
                                        onConfirm();
                                    }}
                                >
                                    Confirmar
                                </Button>
                            )}
                    </footer>
                </ClientStepForm>
            </FormControl>
        </ClientStepRoot>
    );
};

export default ClientStep;
